import { z } from 'zod';

export const commentaryEmbedSchema = z
	.object({
		url: z.string().optional(),
		id: z.union([z.number(), z.string()]).optional(),
		html: z.string().optional(),
		htmlNoScript: z.string().optional(),
		type: z.string().optional(),
		version: z.string().optional(),
		title: z.string().optional(),
		author: z.string().optional(),
		authorUrl: z.string().optional(),
		providerName: z.string().optional(),
		thumbnailUrl: z.string().optional(),
		thumbnailWidth: z.number().optional(),
		thumbnailHeight: z.number().optional(),
		description: z.string().optional(),
		cacheAge: z.number().optional(),
	})
	.passthrough();

export const commentaryImageSchema = z
	.object({
		url: z.string().optional(),
		altText: z.string().nullable().optional(),
		width: z.number().optional(),
		height: z.number().optional(),
		imageVariants: z
			.array(
				z
					.object({
						alias: z.string().optional(),
						url: z.string().optional(),
					})
					.passthrough()
			)
			.optional(),
	})
	.passthrough();

export const commentaryPostSchema = z
	.object({
		id: z.number(),
		title: z.string().nullable().optional(),
		content: z.string().nullable().optional(),
		icon: z.string().nullable().optional(),
		matchTime: z.string().nullable().optional(),
		extraTime: z.string().nullable().optional(),
		dataAdded: z.string().optional(),
		dateUpdated: z.string().optional(),
		embed: commentaryEmbedSchema.nullable().optional(),
		image: commentaryImageSchema.nullable().optional(),
	})
	.passthrough();

export const matchCommentarySchema = z
	.object({
		commentaryLabel: z.string().optional(),
		commentator: z
			.object({
				name: z.string().optional(),
				twitterHandle: z.string().optional(),
				twitterUrl: z.string().optional(),
			})
			.passthrough()
			.nullable()
			.optional(),
		eventId: z.union([z.number(), z.string()]).optional(),
		totalNumberOfPages: z.number().optional(),
		currentPage: z.number().optional(),
		nextPage: z.number().optional(),
		hasLoadMore: z.boolean().optional(),
		loadMoreText: z.string().optional(),
		items: z.array(commentaryPostSchema).default([]),
	})
	.passthrough();

export type CommentaryEmbed = z.infer<typeof commentaryEmbedSchema>;
export type CommentaryImage = z.infer<typeof commentaryImageSchema>;
export type CommentaryPost = z.infer<typeof commentaryPostSchema>;
export type MatchCommentary = z.infer<typeof matchCommentarySchema>;
